export const queryKeys = {
  users: {
    all: ['users'] as const,
    list: (params?: Record<string, string | number | boolean | undefined>) =>
      [...queryKeys.users.all, 'list', params ?? {}] as const,
    detail: (userId: number | string) =>
      [...queryKeys.users.all, 'detail', userId] as const,
  },
  notifications: {
    all: ['notifications'] as const,
    list: (page: number) => [...queryKeys.notifications.all, 'list', page] as const,
  },
  files: {
    all: ['files'] as const,
    list: (email: string, page?: number) =>
      [...queryKeys.files.all, 'list', email, page ?? 1] as const,
  },
} as const;
